export default "__VITE_ASSET__CtUyRYYz__"